import { removeLeadingSlash, removeTrailingSlash } from '../utils';

async function fetchClient({
  fullURL = '',
  endpoint,
  data,
  apiURL,
  token,
  headers: customHeaders,
  ...customConfig
}) {
  const config = {
    method: data ? 'POST' : 'GET',
    body: data ? JSON.stringify(data) : undefined,
    headers: {
      Authorization: token ? `Bearer ${token}` : undefined,
      'Content-Type': data ? 'application/json' : undefined,
      ...customHeaders,
    },
    ...customConfig,
  };

  const url = fullURL
    ? fullURL
    : `${apiURL ? `${removeTrailingSlash(apiURL)}/` : ''}${
        endpoint ? removeLeadingSlash(endpoint) : ''
      }`;

  return window
    .fetch(url, config)
    .then(async (response) => {
      const data = await response.json();
      if (response.ok) {
        return data;
      } else {
        return Promise.reject(data);
      }
    })
    .catch((error) => {
      throw new Error(
        `${apiURL ? apiURL : ''}${
          endpoint ? `/${endpoint}` : ''
        }: ${JSON.stringify(error)}`
      );
    });
}

async function fetchClientHtml({
  endpoint,
  data,
  apiURL,
  token,
  headers: customHeaders,
  ...customConfig
}) {
  const config = {
    method: data ? 'POST' : 'GET',
    body: data ? data : undefined,
    headers: {
      Authorization: token ? `Bearer ${token}` : undefined,
      'Content-Type': data ? 'text/html' : undefined,
      ...customHeaders,
    },
    ...customConfig,
  };

  const url = `${apiURL ? `${apiURL}/` : ''}${endpoint ? endpoint : ''}`;

  return window
    .fetch(url, config)
    .then(async (res) => {
      const data = await res.text();
      if (res.ok) {
        return data;
      } else {
        return Promise.reject(data);
      }
    })
    .catch((error) => {
      throw new Error(`${apiURL}/${endpoint}: ${error}`);
    });
}

const apiTypes = {
  statsAPI: 'statsAPI',
  d3SportsAPI: 'd3SportsAPI',
  forgeDAPI: 'forgeDAPI',
};

export { fetchClient, fetchClientHtml, apiTypes };
